import React, { useEffect,useRef } from "react";
import PropTypes from "prop-types";
import Highcharts from "highcharts";
import {  CaloriesChallengeIcon, MilesChallengeIcon, StepIcon } from "../../utils/icons";


const DailyProgressGraph = ({ value, max , ActivityType}) => {
  const chartRef = useRef(null);


  const getProgressColor = (percentage) => {
    if (percentage >= 0 && percentage <= 40) return "#F37A65";
    if (percentage >= 41 && percentage <= 70) return "#DA9B6C";
    if (percentage >= 71 && percentage <= 100) return "#75B084";
    if (percentage >= 100) return "#75B084";
    return "#F37A65";
  };


  const percentage = max ? Math.round((value / max) * 100) : 0;
  const progressColor = getProgressColor(percentage);


  useEffect(() => {
    if (!chartRef.current) return;

    Highcharts.chart(chartRef.current, {
      chart: {
        type: 'solidgauge',
        // renderTo: id,
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },

      title: null,

      credits: {
        enabled: false
      },

      tooltip: {
        enabled: false
      },

      pane: {
        startAngle: -159.9,
        endAngle: 159.9,
        background: [],
      },
 
      yAxis: {
        min: 0,
        max: max,
        lineWidth: 0,
        tickPositions: []
      },
 
      plotOptions: {
        series: {
          states: {
            inactive: {
              opacity: 1
            }
          }
        },
        solidgauge: {
          rounded: true,
          linecap: 'round',
          dataLabels: {
            enabled: false
          },
          stickyTracking: false,
          // rounded: parseFloat(payload.percent_calories) > 0
        }
      },
 
      // series: [{
      //   name: 'Total',
      //   data: [{
      //     color: progressColor,
      //     radius: '112%',
      //     innerRadius: '93%',
      //     // y: value,
      //     y: value === 0 ? 0.0001 : value
      //   }],
      // }]
      series: [
        {
          name: "background",
          data: [{
            y: max,
            color: 'rgba(239,239,239,1)',
            radius: "112%",
            innerRadius: "93%"
          }],
          rounded: true,
          enableMouseTracking: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        {
          name: "progress",
          data: [{
            y: value === 0 ? 0.0001 : value,
            color:progressColor,
            radius: "112%",
            innerRadius: "93%"
          }],
          rounded: true,
          states: {
            hover: {
              enabled: false
            }
          }
        }
      ]
    });
    
    
  }, [value, max,ActivityType]);

  return (
    <div style={{ position: "relative", width: 160 }}>
      <div ref={chartRef} />

      {/* Center Icon */}
      <div
        style={{
          position: "absolute",
          top: "51%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {ActivityType === "steps" ? StepIcon() : ActivityType === "miles" ? MilesChallengeIcon() : CaloriesChallengeIcon()  }
      </div>
    </div>
  );
};



DailyProgressGraph.propTypes = {
  value: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  selectedDate: PropTypes.string.isRequired,
  challengeDetails: PropTypes.object.isRequired,
  ActivityType: PropTypes.string.isRequired,
};


export default DailyProgressGraph;
